// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpDataDeclarationsTitulo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_data_declarations_titulo";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpDataDeclarationsTitulo {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Dataerklæringer",
                "de": "Datenangaben",
                "en": "Data declarations",
                "es": "Declaraciones de datos",
                "fr": "Déclarations de données",
                "it": "Dichiarazioni sui dati",
                "nl": "Gegevensverklaringen",
                "pt": "Declarações de dados",
                "ru": "Декларации данных",
                "pt-BR": "Declarações de dados"
            },
            "defecto": "Data declarations"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
